<template>
  <div class="property-list-container">
    <div class="wrapper-content" :style="computedFilters">
      <header class="header-list flex">
        <div class="sub-header flex">
          <div class="title-page">
            <h1>Les projets</h1>
          </div>
          <router-link class="cta align-right" :to="{ name: 'create-project' }"><plusSVG />Créer un projet</router-link>
        </div>
      </header>
      <div class="table-list">
        <ul class="labels">
          <li>
            <button>Titre</button>
          </li>
          <li>
            <button>Catégorie</button>
          </li>
        </ul>
        <div class="elements">
          <div class="line" v-for="p in projects" :key="p.token">
            <router-link :to="{ name: 'edit-project', params: { token: p.token } }">
              <div>{{ p.title ? p.title : "-" }}</div>
              <div>{{ p.category ? translations[p.category] : "-" }}</div>
            </router-link>
          </div>
          <span class="no-element" v-if="projects.length < 1">Pas de projet</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import plusSVG from "@/assets/img/plus.svg";

export default Vue.extend({
  components: { plusSVG },
  name: "PropertiesList",
  computed: {
    computedFilters() {
      if (this.isFilters) {
        return {
          width: "calc(100% - 300px)",
          "margin-left": "300px",
        };
      }
      return {};
    },
    paramsURLFilters() {
      let url = "";
      for (let prop in this.filters) {
        if (this.filters[prop] !== null) {
          if (prop === "bedrooms" || prop === "bathrooms") {
            url += prop + "[e]=" + this.filters[prop] + "&";
          } else if (prop === "price") {
            const [from, to] = this.filters[prop].split("-");
            url += prop + "[l]=" + to + "&";
            url += prop + "[g]=" + from + "&";
          } else if (prop === "type" || prop === "status") {
            url += prop + "[]=" + this.filters[prop] + "&";
            url += prop + "[]=" + this.filters[prop] + "&";
          }
        }
      }
      url = url.substr(0, url.length - 1);
      return url;
    },
  },
  watch: {
    search() {
      this.$axios.get("/api/properties?" + this.paramsURLFilters + "&search=" + this.search).then((res) => {
        this.properties = res.data;
      });
    },
    filters: {
      handler() {
        this.$axios.get("/api/properties?" + this.paramsURLFilters + "&search=" + this.search).then((res) => {
          this.properties = res.data;
        });
      },
      deep: true,
    },
  },
  data() {
    return {
      translations: {
        "in-progress": "En cours",
        habitations:"Habitations",
        transformations:"Transformations",
        "appartments-building":"Immeuble à appartement",
        mix:"Programmes mixtes"
      },
      isFilters: false,
      projects: [],
      filters: {},
      search: "",
      sort: {
        name: "",
        direction: "asc",
      },
    };
  },
  methods: {
    orderListBy(element) {
      let _this = this;
      this.properties = this.properties.sort(function(a, b) {
        let A = a[element];
        let B = b[element];
        if (_this.sort.name === element && _this.sort.direction === "asc") {
          if (typeof a[element] === "string") {
            A = a[element].toUpperCase();
            B = b[element].toUpperCase();
          }
          const C = A;
          A = B;
          B = C;
        }

        return A < B ? -1 : A > B ? 1 : 0;
      });
      _this.sort.direction = _this.sort.name === element && _this.sort.direction === "asc" ? "desc" : "asc";
      _this.sort.name = element;
    },
  },
  mounted() {
    this.$axios.get("/api/projects").then((res) => {
      this.projects = res.data.reverse();
    });
  },
});
</script>

<style lang="scss" scoped>
.labels li {
  flex-basis: 20%;
}

.elements .line div {
  flex-basis: 20%;
}
</style>
